import { useNavigate, useOutletContext } from 'react-router-dom'

import { EmployeesPersonalPageDocument } from 'generated/resources/graphql'
import compact from 'lodash/compact'

import Loading from 'modules/core/components/Loading'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import Personal from 'modules/employees/components/Personal'
import { RouteContext } from 'modules/employees/lib/types'

const PersonalPage = () => {
  const { employee, canSeePersonalInfo, loading } = useOutletContext<RouteContext>()

  const navigate = useNavigate()
  const { navigation } = useNavigation()

  useEffect(() => {
    // it can also be null if it's still loading the permission
    // that's why we check for false specifically
    if (!canSeePersonalInfo && !loading) {
      // Return to the employee profile in case the user doesn't have permission
      // to see the personal info.
      // This can happen if you navigate directly to /personal with your browser.
      navigate(navigation.employees.id.fullPath({ id: employee.attributes.id }))
    }
  }, [canSeePersonalInfo, employee.attributes.id, loading])

  const { data, loading: loadingCustomFields } = useQuery(EmployeesPersonalPageDocument, {
    variables: {
      employeeId: employee.id,
      usageGroupSlugs: ['general-information', 'identification-number', 'basic-information'],
    },
  })

  const customResourceFieldsData = compact(
    data?.customFields?.resourceFields.filter((resourceField) => !!resourceField?.field) ?? []
  )
  const customValuesData = data?.employees?.employeesConnection?.edges?.[0]?.node?.values ?? []

  if (loading || loadingCustomFields) {
    return <Loading />
  }

  return (
    <Personal
      customResourceFieldsData={customResourceFieldsData}
      customValuesData={customValuesData}
    />
  )
}

export default PersonalPage
